import React, { useEffect, useState } from 'react'
import { all_routes } from '../router/all_routes'
import { useNavigate, Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';
import * as func from "../common/manipurCommon/FunctionCalls";
import * as api from "../common/manipurCommon/API";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const PasswordReset = () => {
    const routes = all_routes;
    const navigate = useNavigate()

    const [resetId, setResetId] = useState('');
    const [password, setPassword] = useState('');
    const [cnfmPassword, setCnfmPassword] = useState('');
    const [message, setMessage] = useState('')
    const [colour, setColour] = useState('')
    const [pwdError, setPwdError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showFields, setShowFields] = useState(false);

    const { token } = useParams<{
        token: string;
    }>();

    useEffect(() => {
        async function fetchRoles() {
            setIsLoading(true);
            const response = await func.verifyToken(token);
            if (response.error == true) {
                setColour('red')
                setMessage(response.message)
                setShowFields(false)
            } else {
                setShowFields(true)
            }
            setIsLoading(false);
        }
        fetchRoles();
    }, []);

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };

    function pwdReset() {
        const formData = new FormData();
        formData.append('password', password);
        formData.append('confirmPassword', cnfmPassword);
        const reset = api.ResetPassword + "/" + token;
        fetch(reset, {
            method: "POST",
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            navigate(routes.manipurlogin)
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <div className='main-wrapper authendication-pages'>
            <div className="content blur-ellipses">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 mx-auto vph-100 d-flex align-items-center">
                            <div className="forgot-password w-100">
                                <header className="text-center forgot-head-title">
                                    <Link to={routes.home}>
                                        <ImageWithBasePath src="assets/img/Tenvic/TENVICLogo.png" className="img-fluid" alt="Logo" />
                                    </Link>
                                </header>
                                <h4 className='text-center' style={{ color: colour }}>{message}</h4>
                                {showFields &&
                                    <div className="shadow-card">
                                        <h6 className='text-center'><i className='fas fa-key' />Set New Password</h6>
                                        {/* Reset Password Form */}
                                        <form action="login">
                                            <div className="form-group">
                                                <div className="col-lg-12 mb-10">
                                                    <label className="form-label">Password</label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                        id="pwd"
                                                        value={password}
                                                        onChange={(e) => { setPassword(e.target.value) }}
                                                        placeholder="Password"
                                                    />
                                                </div>
                                                <div className="col-lg-12 mb-10">
                                                    <label className="form-label">Confirm Password</label>
                                                    {pwdError && <div className="alert alert-danger">{pwdError}</div>}
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                        id="cnfmpwd"
                                                        value={cnfmPassword}
                                                        onChange={(e) => { setCnfmPassword(e.target.value); validatePasswords(password, e.target.value) }}
                                                        placeholder="Confirm Password"
                                                    />
                                                </div>
                                            </div>
                                            <Link to="#" onClick={pwdReset} className="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center">Submit<i className="feather-arrow-right-circle ms-2" /></Link>
                                        </form>
                                        {/* /Reset Password Form */}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordReset;